define([
    'jquery',
    'mainGtm',
    'weborama',
    'pageLoader',
    'popup',
    'matchSize',
    'globalVars',
    'mage/validation',
    'mage/translate',
], ($, mainGtm, weborama, pageLoader, popup, matchSize, { $body }, $t) => {
    return {
        settings: {
            $newsletterPopup: $('#popupSubscribe'),
            $form: $('#popupSubscribeForm'),
            options: {
                title: '',
                modalClass: 'popup-subscribe-modal',
                frameName: '#popupSubscribe',
                subscribeForm: '#popupSubscribeForm',
                email: '#subscribeEmail',
                category: '#category',
                categoryWrapper: '.select-custom',
                consentToMailing: '#subscribeAcceptNewsletter',
                consentToDataProcessing: '#subscribeAccept',
                gtmReferral: 'popup',
            },
            source: '',
        },

        init() {
            this.initEvents();
            this.validateForm();
        },

        initEvents() {
            $body.on(
                'click',
                '.js-open-popup-subscribe',
                this.openPopup.bind(this)
            );
        },

        openPopup(event) {
            event.preventDefault();

            const $target = $(event.currentTarget);

            $('.js-popup-subscribe-content').show();
            $('.js-answer-subscribe-text').hide();

            // eslint-disable-next-line one-var
            const gtmReferral = $target.data('gtm-referral');

            if (gtmReferral !== '') {
                this.settings.options.gtmReferral = gtmReferral;
            }

            popup(this.settings.options);

            this.settings.source = $target.closest('.header').length
                ? 'LpHeaderSubscribe'
                : 'LpFooterSubscribe';
        },

        validateForm() {
            const { $form } = this.settings;

            $form.mage('validation', {
                errorClass: 'mage-error',
                submitHandler: () => {
                    this.sendFormData($form);
                },
            });
        },

        sendFormData($form) {
            $.ajax({
                type: 'post',
                contentType: 'application/json',
                url: $form.attr('action'),
                data: JSON.stringify({
                    role: $form.find('[name="role"]').val(),
                    email: $form.find('[name="email"]').val(),
                }),
                beforeSend() {
                    pageLoader.showLoading();
                },
                complete() {
                    pageLoader.hideLoading();
                    $form.addClass('_send');
                },
                error() {
                    this.showResponse(
                        $t(
                            'An error occurred on the server. Please try to place the order again'
                        )
                    );
                },
                success: data => {
                    if (data) {
                        this.showResponse(data.message);
                        this.clearForm();
                        weborama.pushSubscribtion(
                            $form.find('[name="email"]').val()
                        );
                        mainGtm.pushSubscription(
                            this.settings.options.gtmReferral
                        );
                    }
                },
            });
        },

        showResponse(text) {
            $('.js-popup-subscribe-content').hide();
            $('.js-answer-subscribe-text').text(text).show();
        },

        clearForm() {
            $(
                `${this.settings.options.email}, ${this.settings.options.category}`
            ).val('');
            $(
                `${this.settings.options.consentToMailing}, ${this.settings.options.consentToDataProcessing}`
            ).prop('checked', false);
            $(`${this.settings.options.categoryWrapper}`).addClass('_empty');
        },
    };
});
